module.exports = __webpack_public_path__ + "static/Loja Virtual-b1126b7b87455b8848779cc73bd81fea.svg";